<template>
  <AppHeaderDropdown
    right
    no-caret
  >
    <template slot="header">
     {{ $session.get("nombreUsuario") }}
      <img
        :src="linkFoto"
        class="img-avatar"
        alt=""
      > 
    </template>\
    <template slot="dropdown">
      <b-dropdown-header
        tag="div"
        class="text-center"
      ><strong>Cuenta</strong></b-dropdown-header>
      <b-dropdown-item @click="cerrarSesion"><i class="fa fa-key"></i> Cerrar Sesión</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>


<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
export default {
  name: "DefaultHeaderDropdown",
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {};
  },
  methods: {
    cerrarSesion() {
      window.location.href = this.$session.get("logout");
    }
  },
  computed: {
    linkFoto() {
      return "data:image/png;base64," + this.$session.get("foto");
    }
  }
};
</script>

